import { useEffect, useState } from "react";
import { IoMdArrowDropright, IoMdCheckbox } from "react-icons/io";
import { IoCheckmarkCircleOutline } from "react-icons/io5";
import { getInlineLoader } from "../Helpers";

export default function UnifiedServicePage({
  title,
  kicker,
  intro,
  heroImage,
  overviewTitle = "Service Overview",
  overviewText,
  featureTitle = "What We Deliver",
  features = [],
  focusTitle = "Projects & Delivery",
  focusItems = [],
  testimonyTitle = "Customer Testimony",
  testimonyQuote,
  testimonyAuthor,
  ctaTitle = "Let's Build Your Next Project",
  ctaText = "Talk to our team for a solution tailored to your needs.",
  ctaLabel = "Contact Us",
}) {
  const [ready, setReady] = useState(false);

  useEffect(() => setReady(true), []);

  if (!ready) {
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;
  }

  return (
    <section className="MainBodySection py-5 fr-service-unified">
      <div className="container">
        <div className="fr-service-unified-shell rounded-4 p-3 p-lg-4">
          <div className="fr-service-unified-hero rounded-4 overflow-hidden mb-4">
            <div className="row g-0 align-items-stretch">
              <div className="col-lg-6">
                <div className="p-4 p-lg-5 h-100 d-flex flex-column justify-content-center">
                  <span className="fr-service-unified-kicker">{kicker}</span>
                  <h1 className="font-bold text-primary mt-3 mb-3">{title}</h1>
                  <p className="text-muted font-semi-bold mb-4">{intro}</p>
                  <button className="btn btn-primary text-center px-4 d-inline-flex align-items-center gap-2 fr-btn-pop">
                    {ctaLabel} <IoMdArrowDropright />
                  </button>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="fr-service-unified-media h-100">
                  <img className="fr-service-unified-media-img" src={heroImage} alt={title} />
                </div>
              </div>
            </div>
          </div>

          <div className="fr-service-unified-overview text-center mb-4 p-4 p-lg-5 rounded-4">
            <h3 className="fw-bold text-dark mb-2">{overviewTitle}</h3>
            <p className="text-muted font-semi-bold mb-0">{overviewText}</p>
          </div>

          <div className="mb-4">
            <h4 className="font-bold text-secondary mb-4 text-center">{featureTitle}</h4>
            <div className="row g-4">
              {features.map((item) => (
                <div className="col-md-6 col-lg-4" key={item.title}>
                  <article className="fr-service-unified-card h-100 p-3 p-lg-4 rounded-4">
                    <IoMdCheckbox size={22} className="text-secondary mb-2" />
                    <h6 className="font-bold text-secondary mb-2">{item.title}</h6>
                    <p className="text-dark font-semi-bold mb-0">{item.desc}</p>
                  </article>
                </div>
              ))}
            </div>
          </div>

          <div className="fr-service-unified-focus rounded-4 p-4 p-lg-5 mb-4">
            <h4 className="font-bold text-secondary mb-4 text-center">{focusTitle}</h4>
            <div className="row g-3">
              {focusItems.map((item, index) => (
                <div className="col-md-6 col-lg-3" key={item.title}>
                  <article className="fr-service-unified-step h-100 p-3 rounded-4">
                    <p className="fr-service-unified-step-no mb-2">{String(index + 1).padStart(2, "0")}</p>
                    <h6 className="fw-bold text-primary mb-1">{item.title}</h6>
                    <p className="text-muted font-semi-bold small mb-0">{item.desc}</p>
                  </article>
                </div>
              ))}
            </div>
          </div>

          <div className="fr-service-unified-testimony text-center mb-4 p-4 rounded-4">
            <h5 className="font-bold text-dark mb-3">{testimonyTitle}</h5>
            <p className="text-muted font-semi-bold mb-0">
              "{testimonyQuote}" {testimonyAuthor ? `- ${testimonyAuthor}` : ""}
            </p>
          </div>

          <div className="fr-service-unified-cta text-center p-4 p-lg-5 rounded-4">
            <h4 className="font-bold text-dark mb-3">{ctaTitle}</h4>
            <p className="text-muted font-bold mb-4">{ctaText}</p>
            <button className="btn btn-secondary px-4 py-2 d-inline-flex align-items-center gap-2">
              {ctaLabel} <IoMdArrowDropright size={21} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
